// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Sv2C","filter":"styles_filter__2Xo1s"};